import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Footer from './components/Footer'
import { BiCalendarEvent, BiMenu } from 'react-icons/bi'
import ClipLoader from 'react-spinners/ClipLoader'
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosPodium,
  IoIosQrScanner,
} from 'react-icons/io'
import { IoTicketOutline, IoCalendarOutline, IoCalendarClearOutline } from 'react-icons/io5'
import { RiCalendarEventLine } from 'react-icons/ri'
import {
  BsLock,
  BsHouseDoor,
  BsArrowLeftShort,
  BsPlusCircle,
  BsPerson,
  BsBarChart,
  BsInfoCircle,
  BsList,
  BsSearch,
  BsPeople,
  BsCalendar,
  BsAppIndicator,
  BsBoundingBoxCircles,
  BsPen,
  BsHeart,
} from 'react-icons/bs'
import Header2 from './components/Header2'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import Header5 from './components/Header5'
import EventsDashboardCust from './screens/dashboard/DashboardCust'
import { API_URL } from './config'

class Customerdashboard extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      tickets: [],
      loadBarProgress: true,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    const customername = localStorage.getItem('customername')
    const customerid = localStorage.getItem('customerid')
    document.title = customername + ' - Customer dashboard'

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERTICKETS&subquery=GETTICKETS&customerid=${customerid}&customerdashboard=yes`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ tickets: [], loadBarProgress: false })
        } else {
          this.setState({ tickets: response.data, loadBarProgress: false })
        }
      })
      .catch((error) => console.log(error))
  }

  tickets = () => {
    let activeString = ''
    const customerid = localStorage.getItem('customerid')
    const customername = localStorage.getItem('customername')
    let event = ''

    return (
      <div>
        {this.state.loadBarProgress ? (
          <div className="w-100 text-center">
            <ClipLoader size={25} color="grey" />
          </div>
        ) : (
          <>
            {this.state.tickets.length < 1 ? (
              <div>
                <label
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: 13.5,
                    color: '#5B7083',
                  }}
                >
                  No data found{' '}
                </label>
              </div>
            ) : (
              this.state.tickets.map((item, index) => {
                {
                  item.activation == 1
                    ? (activeString = <IoIosCheckmarkCircleOutline size={18} color="green" />)
                    : (activeString = <IoIosRemoveCircleOutline size={18} color="red" />)
                }

                {
                  item.eventname.length > 20
                    ? (event = item.eventname.substring(0, 20) + '...')
                    : (event = item.eventname)
                }

                let poster = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.thumbnail}`

                return (
                  <div className={'col-lg-12 p-0'}>
                    <div className="item-select w-100">
                      <Link
                        to={{
                          pathname: '/previewtickets',
                          state: {
                            customername: customername,
                            customerid: customerid,
                            eventid: item.eventid,
                            transactiondate: item.transactiondate,
                            venue: item.venue,
                            eventname: item.eventname,
                            eventtime: item.eventtime,
                            eventday: item.eventday,
                            yearcreated: item.yearcreated,
                            theme: item.theme,
                            admissions: item.admissions,
                            totalcost: item.totalcost,
                          },
                        }}
                        className="w-100"
                      >
                        <div className="row" style={{ display: 'flex' }}>
                          {/* <div className="col-lg-2 col-3 col-sm-2 text-center">
                        <div
                          style={{
                            backgroundImage: `url(` + poster + `)`,
                            width: 55,
                            height: 55,
                            borderRadius: 100,
                            backgroundSize: "100%",
                          }}
                        ></div>
                      </div> */}
                          <div className="col-lg-12 col-12 col-sm-10" style={{ cursor: 'pointer' }}>
                            <div
                              style={{
                                backgroundImage: `url(` + poster + `)`,
                                width: 55,
                                height: 55,
                                borderRadius: 100,
                                backgroundSize: '100%',
                                marginRight: 10,
                              }}
                              className="float-left"
                            />
                            <label
                              className="item-names"
                              style={{
                                color: '#000',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                              }}
                            >
                              {event} <br />
                              <label
                                style={{
                                  color: 'grey',
                                  fontWeight: 'normal',
                                  textTransform: 'none',
                                  cursor: 'pointer',
                                }}
                              >
                                {item.eventday}
                              </label>
                            </label>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                )
              })
            )}
          </>
        )}
      </div>
    )
  }

  searchQuery = (text) => {
    let value = text.target.value
    this.setState({ query: value })
    let query = value.split(' ').join('+')
    this.setState({ isLoading: true, loadingMerch: false })
    const customerid = localStorage.getItem('customerid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERTICKETS&subquery=SEARCHTICKETS&search=${query}&customerid=${customerid}&customerdashboard=yes`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        // alert(response.data.val);
        if (response.data.val == 0) {
          this.setState({
            tickets: [],
          })
        } else {
          this.setState({
            tickets: response.data,
          })
        }
        // alert(response.data.search);
      })
      .catch((error) => console.log(error))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    if (localStorage.getItem('customername') === null) {
      return <Redirect to="/login" />
      //   return exit(1);
    } else {
    }
    const customername = localStorage.getItem('customername')
    const customerid = localStorage.getItem('customerid')
    const accounttype = localStorage.getItem('accounttype')

    const { collapsed, isMobile } = this.state
    return (
      <div className="view">
        {/* <Header2 /> */}
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}
        <div
          className="main-content"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? '40px' : '240px',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <EventsDashboardCust />
        </div>
        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Customerdashboard
